<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Editar Turno
            <v-spacer></v-spacer>
            <h5>Día: {{ dia }} - Hora: {{ hora }}</h5>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="9" sm="5" md="5">
              <v-text-field
                v-model="paciente.dni"
                prepend-icon="mdi-account"
                hint="Ingrese el DNI del Paciente y apriete enter o toque fuera de este cuadro de texto. Si el paciente ya existe, se verán sus datos. Si el paciente no existe, complete los datos y al guardar el turno el paciente quedará registrado. Puede también buscar el paciente por apellido y nombre haciendo click en la lupa"
                label="D.N.I *"
                dense
                required
                @keypress="onlyNumber"
                @keypress.enter="$event.target.blur()"
                @blur="buscarPacienteDni"
                :rules="requiredRules"
                maxlength="9"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn color="primary" @click="buscarPaciente">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="4" md="4" v-if="tiposTurno.length">
              <v-select
                :items="tiposTurno"
                v-model="tipoTurno"
                item-text="nombreTipoTurno"
                item-value="idTipoTurno"
                label="Tipo de Turno *"
                dense
                prepend-icon="mdi-account"
                return-object
                no-data-text="No hay Tipos de Turno configurados"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.apellidos"
                prepend-icon="mdi-account"
                label="Apellidos *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upper"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.nombres"
                prepend-icon="mdi-account"
                label="Nombres *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upperNombres"
                dense
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.fechaNac"
                :value="paciente.fechaNac"
                label="Fecha de Nacimiento"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="sexo"
                v-model="paciente.sexo"
                item-text="paciente.sexo"
                item-value="paciente.sexo"
                label="Sexo"
                dense
                prepend-icon="mdi-account"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.direccion"
                prepend-icon="mdi-map-marker"
                label="Direccion"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.localidad"
                prepend-icon="mdi-map-marker"
                label="Localidad"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              v-if="
                (!this.$store.state.usuario.institucion.notificaWA ||
                  this.$store.state.usuario.institucion.idInstitucion === 114 ||
                  this.$store.state.usuario.institucion.idInstitucion ===
                    270) &&
                this.$store.state.usuario.institucion.idInstitucion !== 436
              "
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              v-if="
                (this.$store.state.usuario.institucion.notificaWA &&
                  this.$store.state.usuario.institucion.idInstitucion !== 114 &&
                  this.$store.state.usuario.institucion.idInstitucion !==
                    270) ||
                this.$store.state.usuario.institucion.idInstitucion === 436
              "
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                :label="`Celular ${celularObligatorio ? '*' : ''}`"
                maxlength="50"
                hint="Ingrese el celular con la característica, sin 0, sin 15 y sin guiones. Ej: 1135036549"
                dense
                :rules="
                  celularObligatorio ? celularObligatorioRules : celularRules
                "
                @blur="trimCelular()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="paciente.telefono"
                prepend-icon="mdi-phone"
                label="Telefono"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="paciente.mail"
                prepend-icon="mdi-email"
                :label="`E-mail ${emailObligatorio ? '*' : ''}`"
                :rules="emailObligatorio ? emailRulesObligatorio : emailRules"
                dense
                maxlength="50"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.observaciones"
                prepend-icon="mdi-account"
                label="Observaciones del Paciente"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="turno.observaciones"
                prepend-icon="mdi-account"
                label="Observaciones del Turno"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-select
                :items="obrasSociales"
                item-text="nombre"
                item-value="idObraSocial"
                prepend-icon="mdi-account"
                v-model="obraSocial"
                :label="`${resolveLabel} *`"
                dense
                :no-data-text="resolveNoData"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="numAfiliado"
                prepend-icon="mdi-account"
                label="Nº de Afiliado"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-select
                :items="
                  $store.state.usuario.institucion.idInstitucion === 195
                    ? intervalosCMSM
                    : intervalos
                "
                prepend-icon="mdi-calendar-multiple"
                v-model="turno.cantIntervalos"
                :disabled="turno.entreTurno == 1"
                label="Cantidad turnos a ocupar *"
                dense
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
              v-if="
                $store.state.usuario.institucion.idInstitucion !== 195 ||
                $store.state.usuario.roles.some((rol) =>
                  [1, 12].includes(rol.idRol),
                )
              "
            >
              <v-select
                :items="resolverItemsEstados"
                v-model="estadoTurno"
                item-text="estadoTurno"
                item-value="estadoTurno"
                label="Estado Turno *"
                dense
                prepend-icon="mdi-calendar-multiple"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense v-if="utilizaVideoLlamada">
            <v-col cols="8" md="6" sm="3" class="py-0 my-0">
              <v-switch
                class="py-0 mb-0"
                dense
                v-model="vllamada"
                label="Es Videoconsulta"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <h6 style="color: indigo" v-if="paciente.idPaciente != null">
            {{ tipoPaciente }}
          </h6>
          <v-spacer></v-spacer>
          <v-btn class="mr-1" color="warning" @click.stop="masDatos()"
            >+ Datos</v-btn
          >
          <v-btn class="mr-1" color="primary" @click.stop="verNumeroHC()"
            >N° HC</v-btn
          >
          <v-btn
            v-if="esReceta"
            class="mr-1"
            color="info"
            @click.stop="showModalMedicamentos = true"
          >
            <v-icon left>mdi-pill</v-icon>
            Ver Medicamentos
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="modificarTurno"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
        <BuscarPacienteTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarPacienteTurno>
        <MasDatos
          v-if="paciente.idPaciente"
          :visible="showMasDatos"
          :idTurno="idTurno"
          :idObraSocial="obraSocial"
          :idPaciente="paciente.idPaciente"
          :nombrePaciente="`${paciente.apellidos}, ${paciente.nombres}`"
          @close="showMasDatos = false"
        >
        </MasDatos>
        <NumeroHC
          v-if="paciente.idPaciente"
          :visible="showNumeroHC"
          :idPaciente="paciente.idPaciente"
          @close="showNumeroHC = false"
        />
        <ModalMedicamentos
          :visible="showModalMedicamentos"
          :medicamentos="turno.observaciones"
          @close="showModalMedicamentos = false"
        />
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";
import BuscarPacienteTurno from "../Turnos/BuscarPacienteTurno.vue";
import MasDatos from "../Turnos/MasDatos.vue";
import NumeroHC from "./NumeroHC.vue";
import ModalMedicamentos from "./ModalMedicamentos.vue";

export default {
  data: (vm) => ({
    horaTurno: null,
    paciente: {
      dni: null,
      apellidos: null,
      nombres: null,
      fechaNac: null,
      sexo: null,
      direccion: null,
      localidad: null,
      mail: null,
      telefono: null,
      celular: null,
      observaciones: null,
      antecedentes: "",
      antecedentesFamiliares: "",
      esGestante: false,
      idPaciente: null,
    },
    vllamada: null,
    tmpvllamada: null,
    utilizaVideoLlamada: false,
    showBuscarPaciente: false,
    showMasDatos: false,
    showNumeroHC: false,
    showModalMedicamentos: false,
    siglaTipoTurno: "",
    turno: {
      idTurno: null,
      cantIntervalos: null,
      observaciones: null,
      entreTurno: null,
      usuarioAlta: null,
      fechaAlta: null,
    },
    intervalos: [1, 2, 3, 4, 5, 6, 7, 8],
    intervalosCMSM: [1, 2, 3, 4, 5, 6],
    sexo: ["FEMENINO", "MASCULINO", "OTRO"],
    estados: ["RESERVADO", "EN ESPERA", "ATENDIDO"],
    estadosEmpresas: ["RESERVADO", "EN ESPERA"],
    estadosCmsm: ["RESERVADO", "ATENDIDO"],
    estadoTurno: "",
    valid: false,
    lazy: false,
    tipoPaciente: null,
    obrasSociales: [],
    obraSocial: "",
    numAfiliado: "",
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) ||
        "E-mail inválido",
    ],
    emailRulesObligatorio: [
      (v) =>
        !v ||
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    celularRules: [(v) => !v || v.length == 10 || "Debe tener 10 caracteres"],
    celularObligatorioRules: [
      (v) => !v || v.length == 10 || "Debe tener 10 caracteres",
      (v) => !!v || "Dato obligatorio",
    ],
    tiposTurno: [],
    tipoTurno: null,
    pendingIdTipoTurno: null,
  }),

  props: [
    "visible",
    "dia",
    "hora",
    "idProfesional",
    "tiempoTurno",
    "idTurno",
    "observacionesPaciente",
    "tipoCronograma",
  ],

  components: {
    BuscarPacienteTurno,
    MasDatos,
    NumeroHC,
    ModalMedicamentos,
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.setearModels();
          this.buscarDatosTurno();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.obraSocial = this.obrasSociales[0].idObraSocial;
          this.paciente.dni = "";
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    resolveNoData() {
      return this.$store.state.usuario.institucion.esEmpresa &&
        (this.dni ||
          this.apellidos ||
          this.nombres ||
          this.prof ||
          this.profsBuscar)
        ? "No hay Sedes configuradas"
        : "No hay Obras Sociales configuradas";
    },
    resolveLabel() {
      return this.$store.state.usuario.institucion.esEmpresa
        ? "Sede"
        : "Obra Social";
    },
    resolverItemsEstados() {
      if (this.$store.state.usuario.institucion.esEmpresa) {
        return this.estadosEmpresas;
      }
      return this.estados;
    },
    celularObligatorio() {
      return [195, 436].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      );
    },
    emailObligatorio() {
      return [195].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      );
    },
    esReceta() {
      return this.tipoCronograma === 4;
    },
  },

  methods: {
    masDatos() {
      this.showMasDatos = true;
    },
    verNumeroHC() {
      this.showNumeroHC = true;
    },
    trimCelular() {
      this.paciente.celular = this.paciente.celular
        ? this.paciente.celular.toString().trim()
        : "";
    },
    buscarDatosTurno() {
      const idTurno = this.idTurno;
      let self = this;

      axios
        .get("/Turnos/BuscarDatosTurno?", {
          params: {
            idTurno: this.idTurno,
          },
        })
        .then((response) => {
          self.paciente.dni = response.data.dniPaciente;
          self.paciente.apellidos = response.data.apellidoPaciente;
          self.paciente.nombres = response.data.nombrePaciente;
          if (response.data.fechaNacimiento == "0001-01-01T00:00:00")
            self.paciente.fechaNac = "";
          else
            self.paciente.fechaNac = response.data.fechaNacimiento.substring(
              0,
              10,
            );
          self.paciente.sexo = response.data.sexo;
          self.paciente.localidad = response.data.localidad;
          self.paciente.direccion = response.data.direccion;
          self.paciente.celular = response.data.celular;
          self.paciente.mail = response.data.mail;
          self.paciente.telefono = response.data.telefono;
          self.paciente.observaciones = self.observacionesPaciente;
          self.paciente.antecedentes = response.data.antecedentes;
          self.paciente.antecedentesFamiliares =
            response.data.antecedentesFamiliares;
          self.paciente.esGestante = response.data.esGestante;
          self.paciente.idPaciente = response.data.idPaciente;
          self.tipoPaciente = "Paciente Existente";
          self.turno.cantIntervalos = response.data.cantidadIntervalos;
          self.turno.observaciones = response.data.observaciones;
          self.turno.entreTurno = response.data.entreTurno;
          self.turno.usuarioAlta = response.data.usuarioAlta;
          self.turno.fechaAlta = response.data.fechaAlta;
          self.vllamada = response.data.esVideoLlamada;
          self.tmpvllamada = response.data.esVideoLlamada;
          const estadoTur = response.data.estadoTurno;
          if (
            estadoTur === 3 &&
            self.$store.state.usuario.institucion.esEmpresa
          ) {
            self.estadosEmpresas.push("ATENDIDO");
          }
          if (estadoTur == 1) self.estadoTurno = "RESERVADO";
          if (estadoTur == 2) self.estadoTurno = "EN ESPERA";
          if (estadoTur == 3) self.estadoTurno = "ATENDIDO";

          self.obraSocial = response.data.idObraSocial;
          self.numAfiliado = response.data.numAfiliado;
          self.pendingIdTipoTurno = response.data.idTipoTurno;
          if (self.tiposTurno.length) {
            if (response.data.idTipoTurno) {
              self.tipoTurno = self.tiposTurno.find(
                (tt) => tt.idTipoTurno === response.data.idTipoTurno,
              );
            } else {
              self.tipoTurno = self.tiposTurno.find((tt) => tt.porDefecto);
            }
          }
        })
        .catch((error) => {});
    },
    validarFechaNacimiento() {
      if (this.paciente.fechaNac == null) return true;
      else {
        if (this.paciente.fechaNac.toString().length > 10) return false;
        else return true;
      }
    },
    modificarTurno() {
      this.$swal({
        title: "Modificar Turno",
        text: "¿Desea modificar el turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          if (
            this.vllamada == true &&
            this.tmpvllamada == false &&
            (this.paciente.mail == "" || this.paciente.mail == null)
          ) {
            this.showAlert({
              timer: 3500,
              icon: "error",
              title:
                "El turno se está cambiando de presencial a videoconsulta. Debe completar el email del paciente para poder enviarle el link de la reunión.",
              vm: this,
            });
            return;
          }
          if (
            this.vllamada == false &&
            this.tmpvllamada == true &&
            (this.paciente.mail == "" || this.paciente.mail == null)
          ) {
            this.showAlert({
              timer: 3500,
              icon: "error",
              title:
                "El turno se está cambiando de videoconsulta a presencial. Debe completar el email del paciente para poder notificarle el cambio.",
              vm: this,
            });
            return;
          }
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')
          var estadoTur = 0;
          if (this.estadoTurno == "RESERVADO") estadoTur = 1;
          if (this.estadoTurno == "EN ESPERA") estadoTur = 2;
          if (this.estadoTurno == "ATENDIDO") estadoTur = 3;

          const datosTurno = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            dniPaciente: this.paciente.dni,
            apellidoPaciente: this.paciente.apellidos,
            nombrePaciente: this.paciente.nombres,
            fechaNacimientoString: this.paciente.fechaNac,
            sexo: this.paciente.sexo,
            direccion: this.paciente.direccion,
            localidad: this.paciente.localidad,
            celular: this.paciente.celular ? this.paciente.celular.trim() : "",
            telefono: this.paciente.telefono
              ? this.paciente.telefono.trim()
              : "",
            mail: this.paciente.mail ? this.paciente.mail.trim() : "",
            observaciones: this.paciente.observaciones,
            antecedentes: this.paciente.antecedentes,
            antecedentesFamiliares: this.paciente.antecedentesFamiliares,
            esGestante: this.paciente.esGestante,
            idPaciente: this.paciente.idPaciente,
            fechaTurnoString: this.dia,
            horaInicioString: this.hora,
            cantidadIntervalos: this.turno.cantIntervalos,
            duracionTurno: this.turno.cantIntervalos * this.tiempoTurno,
            idObraSocial: this.obraSocial,
            idprofesional: this.idProfesional,
            estadoTurno: estadoTur,
            esWeb: false,
            esVideoLlamada: this.vllamada,
            tmpVideoLlamada: this.tmpvllamada,
            entreTurno: this.turno.entreTurno,
            idTurno: this.idTurno,
            observacionesTurno: this.turno.observaciones,
            usuarioAlta: this.turno.usuarioAlta,
            fechaAlta: this.turno.fechaAlta,
            usuarioModi: this.$store.state.usuario.usuario,
            siglaTipoTurno: this.tipoTurno?.sigla || "",
            idTipoTurno: this.tipoTurno?.idTipoTurno || 0,
            numAfiliado: this.numAfiliado,
          };
          if (
            datosTurno.apellidoPaciente == null ||
            datosTurno.apellidoPaciente == ""
          ) {
            this.showAlert({
              icon: "error",
              title: "Faltan completar datos obligatorios",
              vm: this,
              timer: 2800,
            });
            return;
          }
          let isValidDate = this.validarFechaNacimiento();
          if (!isValidDate) {
            this.showAlert({
              icon: "error",
              title: "La fecha de nacimiento no tiene un formato válido.",
              vm: this,
              timer: 2800,
            });
            return;
          }
          let self = this;
          axios
            .post("/Turnos/ModificarTurno", datosTurno)
            .then((response) => {
              if (response.data == "Turnos Existentes") {
                self.showAlert({
                  icon: "error",
                  title:
                    "Existen turnos ya reservados dentro de la duración del turno que quiere reservar",
                  vm: self,
                  timer: 3200,
                });
              } else {
                if (response.data == "Tope") {
                  self.showAlert({
                    icon: "error",
                    title: `${
                      self.$store.state.usuario.institucion.esEmpresa
                        ? "El profesional no atiende en la sede seleccionada"
                        : "Supera la cantidad máxima de turnos diarios para la obra social"
                    }`,
                    vm: self,
                    timer: 2800,
                  });
                } else {
                  self.$refs.form.resetValidation();

                  self.obraSocial = this.obrasSociales[0].idObraSocial;
                  self.paciente.dni = "";
                  document.getElementsByClassName(
                    "v-dialog--active",
                  )[0].scrollTop = 0;
                  if (self.vllamada == self.tmpvllamada) {
                    self.showAlert({
                      icon: "success",
                      title: "Turno modificado",
                      vm: self,
                      timer: 2000,
                    });
                  } else {
                    if (self.vllamada == false) {
                      self.showAlert({
                        icon: "success",
                        title:
                          "Turno modificado. Se enviará un correo al paciente notificando el cambio de modalidad del turno.",
                        vm: self,
                        timer: 3500,
                      });
                    } else {
                      self.showAlert({
                        icon: "success",
                        title:
                          "Turno modificado. Se enviará un email al paciente con las instrucciones para la videoconsulta.",
                        vm: self,
                        timer: 3500,
                      });
                    }
                  }
                  self.vaciarModels();
                  self.$emit("turnoModificado");
                }
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El turno no pudo ser modificado",
                vm: this,
                timer: 2000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    seleccionarPaciente(item) {
      this.paciente.dni = item.nrodocumento;
      this.paciente.apellidos = item.apellidos;
      this.paciente.nombres = item.nombres;
      if (item.fechanacimiento == "0001-01-01T00:00:00")
        this.paciente.fechaNac = "";
      else this.paciente.fechaNac = item.fechanacimiento.substring(0, 10);
      this.paciente.sexo = item.sexo;
      this.paciente.localidad = item.localidad;
      this.paciente.direccion = item.direccion;
      this.paciente.celular = item.celular;
      this.paciente.mail = item.email;
      this.paciente.telefono = item.telefono;
      this.paciente.observaciones = item.observaciones;
      this.paciente.antecedentes = item.antecedentes;
      this.paciente.antecedentesFamiliares = item.antecedentesFamiliares;
      this.paciente.esGestante = item.esGestante;
      this.paciente.idPaciente = item.idpaciente;
      this.tipoPaciente = "Paciente Existente";
      this.showBuscarPaciente = false;
      axios
        .get("/Paciente/BuscarDatosAfiliatorios?", {
          params: {
            idPaciente: item.idpaciente,
          },
        })
        .then((response) => {
          if (response.data != null && response.data != "") {
            this.obraSocial = response.data.idObraSocial;
            this.numAfiliado = response.data.nroAfiliado;
          }
        });
    },

    buscarPacienteDni() {
      if (isNaN(this.paciente.dni)) {
        this.showAlert({
          timer: 3200,
          icon: "error",
          title: "El D.N.I. debe estar compuesto sólo por números.",
          vm: this,
        });
        this.paciente.dni = "";
        this.paciente.idPaciente = 0;
        return;
      }
      if (this.paciente.dni != "" && this.paciente.dni != null)
        this.paciente.dni = parseInt(this.paciente.dni);

      const pacientesData = {
        dni: this.paciente.dni,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Paciente/GetPacienteDniTurno?", {
          params: {
            dni: pacientesData.dni,
            idInstitucion: pacientesData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "") {
            self.paciente.apellidos = response.data.apellidos;
            self.paciente.nombres = response.data.nombres;
            self.paciente.idPaciente = response.data.idpaciente;
            if (response.data.fechanacimiento == "0001-01-01T00:00:00")
              self.paciente.fechaNac = "";
            else
              self.paciente.fechaNac = response.data.fechanacimiento.substring(
                0,
                10,
              );
            self.paciente.sexo = response.data.sexo;
            self.paciente.direccion = response.data.direccion;
            self.paciente.localidad = response.data.localidad;
            self.paciente.telefono = response.data.telefono;
            self.paciente.celular = response.data.celular;
            self.paciente.mail = response.data.email;
            self.paciente.antecedentes = response.data.antecedentes;
            self.paciente.antecedentesFamiliares =
              response.data.antecedentesFamiliares;
            self.esGestante = response.data.esGestante;
            self.paciente.observaciones = response.data.observaciones;
            self.tipoPaciente = "Paciente Existente";
            if (response.data.datosAfiliatorios.idObraSocial != null)
              self.obraSocial = response.data.datosAfiliatorios.idObraSocial;
            if (response.data.datosAfiliatorios.nroAfiliado != null) {
              self.numAfiliado = response.data.datosAfiliatorios.nroAfiliado;
            }
          } else {
            self.vaciarModels();
            self.paciente.idPaciente = 0;
            self.tipoPaciente = "Paciente Nuevo";
          }
        })
        .catch(function (error) {});
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    upper() {
      if (this.paciente.apellidos != null)
        this.paciente.apellidos = this.paciente.apellidos
          .toString()
          .toUpperCase();
    },
    upperNombres() {
      if (this.paciente.nombres != null)
        this.paciente.nombres = this.paciente.nombres.toString().toUpperCase();
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    vaciarModels() {
      this.paciente.apellidos = "";
      this.paciente.nombres = "";
      this.paciente.direccion = "";
      this.paciente.localidad = "";
      this.paciente.celular = "";
      this.paciente.telefono = "";
      this.paciente.mail = "";
      this.paciente.observaciones = "";
      this.paciente.antecedentes = "";
      this.paciente.antecedentesFamiliares = "";
      this.paciente.esGestante = false;
      this.paciente.fechaNac = null;
      this.paciente.sexo = null;
      this.paciente.idPaciente = null;
      this.turno.cantIntervalos = 1;
      this.turno.observaciones = "";
      this.numAfiliado = "";
      //this.utilizaVideoLlamada = false;
      this.vllamada = false;
      this.showModalMedicamentos = false;
      //this.obraSocial = this.obrasSociales[0].idObraSocial;
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
    async setearModels() {
      this.utilizaVideoLlamada =
        this.$store.state.usuario.institucion.utilizaVideoLlamada;
      const osData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        idProfesional: this.idProfesional,
      };

      let self = this;
      const osEndpoint =
        this.$store.state.usuario.institucion.idInstitucion === 285
          ? "/ObraSocial/GetObraSocialActivasDeInstSinTope?"
          : "/ObraSocial/GetObraSocialActivasDeInst?";
      axios
        .get(osEndpoint, {
          params: {
            idInstitucion: osData.idInstitucion,
            idProfesional: osData.idProfesional,
          },
        })
        .then((response) => {
          self.obrasSociales = response.data;
        })
        .catch((error) => {});

      const { data: tiposTurno } = await axios.get(
        `/Profesional/${this.idProfesional}/tipos-turno`,
      ).catch(() => axios.get(
        "/Profesional/GetTiposTurno",
        {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        },
      ));
      this.tiposTurno = tiposTurno || [];
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    tiposTurno(val) {
      if (val && val.length && this.pendingIdTipoTurno) {
        this.tipoTurno = val.find(
          (tt) => tt.idTipoTurno === this.pendingIdTipoTurno
        );
      } else if (val && val.length && !this.pendingIdTipoTurno) {
        this.tipoTurno = val.find((tt) => tt.porDefecto);
      }
    },
    async idProfesional(newVal) {
      // Actualizar tipos de turno cada vez que cambia el profesional seleccionado
      if (newVal) {
        try {
          const { data: tiposTurno } = await axios.get(
            `/Profesional/${newVal}/tipos-turno`,
          );
          this.tiposTurno = tiposTurno || [];
        } catch (e) {
          const { data: tiposTurno } = await axios.get(
            "/Profesional/GetTiposTurno",
            {
              params: {
                idInstitucion:
                  this.$store.state.usuario.institucion.idInstitucion,
              },
            },
          );
          this.tiposTurno = tiposTurno || [];
        }
      }
    },
    // idTurno(val) {
    //   if(val>0)
    //   {
    //    this.buscarDatosTurno()
    //   }
    // }
  },
  created() {
    this.vaciarModels();
  },
};
</script>
